import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Inner, Text, Spinner } from "./styles/saving-styles";
import spinner from "./img/loading.gif";

const Saving = ({
  purple,
  darkPurple,
  white,
  grey,
  smallFont,
  mediumFont,
  noText,
}) => (
  <Wrapper
    purple={purple}
    white={white}
    darkPurple={darkPurple}
    grey={grey}
    smallFont={smallFont}
    mediumFont={mediumFont}
  >
    <Inner noText={noText}>
      <Spinner
        src={spinner}
        alt="Saving spinner"
        smallFont={smallFont}
        mediumFont={mediumFont}
      />
      {!noText && <Text>Saving...</Text>}
    </Inner>
  </Wrapper>
);

Saving.propTypes = {
  purple: PropTypes.bool,
  darkPurple: PropTypes.bool,
  white: PropTypes.bool,
  grey: PropTypes.bool,
  smallFont: PropTypes.bool,
  mediumFont: PropTypes.bool,
  noText: PropTypes.bool,
};

Saving.defaultProps = {
  purple: PropTypes.isNull,
  darkPurple: PropTypes.isNull,
  white: PropTypes.isNull,
  grey: PropTypes.isNull,
  smallFont: PropTypes.isNull,
  mediumFont: PropTypes.isNull,
  noText: PropTypes.isNull,
};

export default Saving;
